import { Recipient } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { useGetDisplayName } from '@frontend/get-display-name';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Checkbox, ListRow, phone } from '@frontend/design-system';
import { useAudienceTray } from '../providers/audience-tray-provider';

type Props = {
  checked: boolean;
  disabled?: boolean;
  isTextCampaign: boolean;
  onClick: (recipient: Recipient) => void;
  recipient: Recipient;
  search: string;
};

export const RecipientItem = ({ checked, disabled, isTextCampaign, onClick, recipient, search }: Props) => {
  const { t } = useTranslation('bulk-messaging');
  const { trackingIdPrefix } = useAudienceTray();

  const { fullName } = useGetDisplayName({
    person: {
      firstName: recipient.firstName || '',
      lastName: recipient.lastName || '',
      preferredName: recipient.preferredName || '',
    },
  });

  let destination = recipient.destination;
  if (search && recipient.personId?.includes(search)) {
    destination = t('ID: {{patientId}}', { patientId: recipient.personId });
  } else if (search && recipient.recipientId?.includes(search)) {
    destination = t('ID: {{patientId}}', { patientId: recipient.recipientId });
  } else if (isTextCampaign) {
    destination = phone(recipient.destination, { format: 'standard', hideCountry: true });
  }

  return (
    <ListRow
      as='div'
      onClick={() => onClick(recipient)}
      css={{
        padding: theme.spacing(1, 2),
        backgroundColor: disabled ? theme.colors.neutral5 : theme.colors.white,
        cursor: disabled ? 'not-allowed !important' : 'pointer',
        userSelect: 'none',
      }}
      data-trackingid={`${trackingIdPrefix}-recipient-item`}
    >
      <ListRow.Lead>
        {/* @ts-ignore purposefully omitting all of the checkbox's props */}
        <Checkbox value={checked} onChange={() => {}} name={recipient.destination} disabled={disabled} />
      </ListRow.Lead>
      <ListRow.Content>
        <ListRow.Content.Title>{fullName}</ListRow.Content.Title>
        <ListRow.Content.Subtitle>{destination}</ListRow.Content.Subtitle>
      </ListRow.Content>
    </ListRow>
  );
};
